module.exports = __webpack_public_path__ + "img/Facebook.8f5ce275.png";